module.exports = __webpack_public_path__ + "img/636D6C_D4E7ED_ABBCC4_9BA4A8-256px.f1c7b5ed.png";